import { DataKiSyokenResponse } from './types';

export const dataKiSyokenFilteredByKiList = (
  dataKiSyoken: DataKiSyokenResponse,
  kiListFilter: string[] | undefined
): DataKiSyokenResponse => {
  if (kiListFilter == null || kiListFilter.length === 0) {
    return dataKiSyoken;
  }

  const kiListFilterSet = new Set(kiListFilter);

  const rows = dataKiSyoken.data.rows.filter((row) => {
    if (row.queryParameter.value == null) {
      return true;
    }

    return kiListFilterSet.has(row.queryParameter.value);
  });

  return {
    ...dataKiSyoken,
    data: {
      ...dataKiSyoken.data,
      rows,
    },
  };
};
